import allCss from './css.js'

export default {
  'Default-Gambling Buttons': {
    includeInShowcase: true,
    label: 'Default-Gambling Buttons',
    config: {
      merchantId: '198003',
      userId: 'PayTestMT',
      sessionId: '1234',
      environment: 'test',
      method: 'deposit',
      containerHeight: '900px',
      containerWidth: '900px',
      accountDelete: false,
      accountId: null,
      trackingPixels: null,
      additionalCashierText: true,
      allowCancelPendingWithdrawal: true,
      allowUserToDisableCancelWithdrawals: false,
      alwaysShowSubmitBtn: true,
      amount: null,
      amountFirst: false,
      font: 'google,gilroy',
      autoOpenFirstPaymentMethod: true,
      autoProcess: false,
      bonusCode: null,
      channelId: null,
      country: '',
      disableBtnAtZero: true,
      displayLogoOrName: 'logo',
      errorMsgTxRefId: false,
      feeAmount: [],
      gaTag: null,
      globalSubmit: true,
      history: true,
      isMobile: false,
      layout: 'horizontal',
      listRadio: true,
      listType: 'grid',
      locale: '',
      logoFullWidth: true,
      logoSize: 120,
      logoUrl: 'https://static.paymentiq.io/misc/ChipsDepositIconWhite.png',
      mode: 'gambling',
      pmListLimit: '6',
      pollLimit: 5,
      predefinedAmounts: '10,25,50,100,250,500',
      predefinedValues: true,
      preventCancelWithdrawal: false,
      providerType: null,
      receiptAmountDisplayStyle: 'symbol',
      receiptAmountTransactionStyle: 'TxAmount',
      receiptExcludeKeys: [],
      showReceipt: true,
      saveAccountOption: false,
      scrollToOffset: 0,
      scrollToPm: 'nearest',
      selectlastusedtxmethod: false,
      showAccounts: 'inline',
      showAmountLimits: true,
      showBonusCode: false,
      showFee: true,
      showFooter: false,
      showHeader: true,
      showListHeaders: false,
      showTermsConditions: false,
      showTransactionOverview: true,
      singlePageFlow: false,
      storeAccount: true,
      tabs: true,
      zebraffeLoader: true,
      showTransactionsOnly: false,
      hideTxOverview: false,
      allowMobilePopup: false,
      fetchConfig: false
    },
    theme: {
      input: {
        color: '#222324',
        fontSize: '14px',
        height: '52px',
        borderRadius: '15px'
      },
      inputbackground: {
        color: '#ffffff'
      },
      labels: {
        color: '#000000',
        fontSize: '12px'
      },
      headings: {
        color: '#333',
        fontSize: '14px'
      },
      loader: {
        color: '#46beab'
      },
      error: {
        color: '#ED5F7B'
      },
      buttons: {
        color: '#46beab'
      },
      headerbackground: {
        color: '#46beab'
      },
      background: {
        color: '#ffffff'
      },
      cashierbackground: {
        color: '#ffffff'
      },
      cardbackground: {
        color: 'transparent'
      },
      border: {
        radius: '15px'
      },
      margin: {
        size: '14px'
      },
      creditcardicons: {
        creditcardUrl: 'default',
        cvvUrl: 'default',
        expirydateUrl: 'default'
      }
    },
    style: ''
  },
  'Default-Gambling List': {
    label: 'Default-Gambling List',
    config: {
      merchantId: '198003',
      userId: 'PayTestMT',
      sessionId: '123',
      environment: 'test',
      method: 'deposit',
      containerHeight: '900px',
      containerWidth: '950px',
      accountDelete: false,
      accountId: null,
      trackingPixels: null,
      additionalCashierText: true,
      allowCancelPendingWithdrawal: true,
      allowUserToDisableCancelWithdrawals: false,
      alwaysShowSubmitBtn: true,
      amount: null,
      amountFirst: false,
      font: 'google,gilroy',
      autoOpenFirstPaymentMethod: true,
      autoProcess: false,
      bonusCode: null,
      channelId: null,
      country: '',
      disableBtnAtZero: true,
      displayLogoOrName: 'both',
      errorMsgTxRefId: false,
      feeAmount: [],
      gaTag: null,
      globalSubmit: true,
      history: true,
      isMobile: false,
      layout: 'horizontal',
      listRadio: true,
      listType: 'list',
      locale: '',
      logoFullWidth: true,
      logoSize: 120,
      logoUrl: 'https://static.paymentiq.io/misc/ChipsDepositIconWhite.png',
      mode: 'gambling',
      pmListLimit: '5',
      pollLimit: 5,
      predefinedAmounts: '10,25,50,100,250,500',
      predefinedValues: true,
      preventCancelWithdrawal: false,
      providerType: null,
      receiptAmountDisplayStyle: 'symbol',
      receiptAmountTransactionStyle: 'TxAmount',
      receiptExcludeKeys: [],
      showReceipt: true,
      saveAccountOption: false,
      scrollToOffset: 0,
      scrollToPm: 'nearest',
      selectlastusedtxmethod: false,
      showAccounts: 'inline',
      showAmountLimits: true,
      showBonusCode: false,
      showFee: true,
      showFooter: true,
      showHeader: true,
      showListHeaders: false,
      showTermsConditions: false,
      showTransactionOverview: true,
      singlePageFlow: false,
      storeAccount: true,
      tabs: true,
      zebraffeLoader: true,
      showTransactionsOnly: false,
      hideTxOverview: false,
      allowMobilePopup: false,
      fetchConfig: false
    },
    theme: {
      input: {
        color: '#222324',
        fontSize: '14px',
        height: '52px',
        borderRadius: '15px'
      },
      inputbackground: {
        color: '#ffffff'
      },
      labels: {
        color: '#000000',
        fontSize: '12px'
      },
      headings: {
        color: '#333',
        fontSize: '14px'
      },
      loader: {
        color: '#46beab'
      },
      error: {
        color: '#ff2e56'
      },
      buttons: {
        color: '#46beab'
      },
      headerbackground: {
        color: '#46beab'
      },
      background: {
        color: '#ffffff'
      },
      cashierbackground: {
        color: '#ffffff'
      },
      cardbackground: {
        color: 'transparent'
      },
      border: {
        radius: '15px'
      },
      margin: {
        size: '14px'
      },
      creditcardicons: {
        creditcardUrl: 'default',
        cvvUrl: 'default',
        expirydateUrl: 'default'
      }
    },
    style: ''
  },
  'Default-Gambling ListBox': {
    includeInShowcase: true,
    label: 'Default-Gambling ListBox',
    config: {
      merchantId: '198003',
      userId: 'PayTestMT',
      sessionId: '1234',
      environment: 'test',
      method: 'deposit',
      containerHeight: '975px',
      containerWidth: '600px',
      accountDelete: false,
      accountId: null,
      trackingPixels: null,
      additionalCashierText: true,
      allowCancelPendingWithdrawal: true,
      allowUserToDisableCancelWithdrawals: false,
      alwaysShowSubmitBtn: true,
      amount: null,
      amountFirst: false,
      font: 'google,gilroy',
      autoOpenFirstPaymentMethod: true,
      autoProcess: false,
      bonusCode: null,
      channelId: null,
      country: '',
      disableBtnAtZero: true,
      displayLogoOrName: 'both',
      errorMsgTxRefId: false,
      feeAmount: [],
      gaTag: null,
      globalSubmit: false,
      history: true,
      isMobile: false,
      layout: 'horizontal',
      listRadio: true,
      listType: 'list',
      locale: 'en',
      logoFullWidth: true,
      logoSize: 120,
      logoUrl: 'https://static.paymentiq.io/misc/ChipsDepositIconWhite.png',
      mode: 'gambling',
      pmListLimit: '5',
      pollLimit: 5,
      predefinedAmounts: '10,25,50,100,250,500',
      predefinedValues: true,
      preventCancelWithdrawal: false,
      providerType: null,
      receiptAmountDisplayStyle: 'symbol',
      receiptAmountTransactionStyle: 'TxAmount',
      receiptExcludeKeys: [],
      showReceipt: true,
      saveAccountOption: false,
      scrollToOffset: 0,
      scrollToPm: 'nearest',
      selectlastusedtxmethod: false,
      showAccounts: 'inline',
      showAmountLimits: true,
      showBonusCode: false,
      showFee: true,
      showFooter: true,
      showHeader: true,
      showListHeaders: false,
      showTermsConditions: false,
      showTransactionOverview: true,
      singlePageFlow: true,
      storeAccount: true,
      tabs: true,
      zebraffeLoader: true,
      showTransactionsOnly: false,
      hideTxOverview: false,
      allowMobilePopup: false,
      fetchConfig: false
    },
    theme: {
      input: {
        color: '#222324',
        fontSize: '16px',
        height: '52px',
        borderRadius: '20px'
      },
      inputbackground: {
        color: '#ffffff'
      },
      labels: {
        color: '#000000',
        fontSize: '12px'
      },
      headings: {
        color: '#333',
        fontSize: '15px'
      },
      loader: {
        color: '#46beab'
      },
      error: {
        color: '#ff2e56'
      },
      buttons: {
        color: '#46beab'
      },
      headerbackground: {
        color: '#46beab'
      },
      background: {
        color: '#ffffff'
      },
      cashierbackground: {
        color: '#ffffff'
      },
      cardbackground: {
        color: 'transparent'
      },
      border: {
        radius: '15px'
      },
      margin: {
        size: '14px'
      },
      creditcardicons: {
        creditcardUrl: 'default',
        cvvUrl: 'default',
        expirydateUrl: 'default'
      }
    },
    style: ''
  },
  'Default-eCommerce Buttons': {
    includeInShowcase: true,
    label: 'Default-eCommerce Buttons',
    config: {
      merchantId: '100211999',
      userId: 'PayTestMT',
      sessionId: '1234',
      environment: 'test',
      method: 'deposit',
      containerHeight: '650px',
      containerWidth: '800px',
      accountDelete: false,
      accountId: null,
      trackingPixels: null,
      additionalCashierText: true,
      allowCancelPendingWithdrawal: false,
      allowUserToDisableCancelWithdrawals: false,
      alwaysShowSubmitBtn: true,
      amount: '49.99',
      amountFirst: false,
      font: 'google,gilroy',
      autoOpenFirstPaymentMethod: true,
      autoProcess: false,
      bonusCode: null,
      channelId: null,
      country: '',
      disableBtnAtZero: false,
      displayLogoOrName: 'logo',
      errorMsgTxRefId: false,
      feeAmount: [],
      gaTag: null,
      globalSubmit: false,
      history: false,
      isMobile: false,
      layout: 'horizontal',
      listRadio: true,
      listType: 'grid',
      locale: '',
      logoFullWidth: false,
      logoSize: 120,
      logoUrl: 'https://static.paymentiq.io/misc/ShoppingCartBuyWhite.png',
      mode: 'ecommerce',
      pmListLimit: '6',
      pollLimit: 5,
      predefinedAmounts: '',
      predefinedValues: false,
      preventCancelWithdrawal: false,
      providerType: null,
      receiptAmountDisplayStyle: 'symbol',
      receiptAmountTransactionStyle: 'TxAmount',
      receiptExcludeKeys: [],
      showReceipt: true,
      saveAccountOption: false,
      scrollToOffset: 0,
      scrollToPm: 'nearest',
      selectlastusedtxmethod: false,
      showAccounts: 'inline',
      showAmountLimits: false,
      showBonusCode: false,
      showFee: false,
      showFooter: false,
      showHeader: true,
      showListHeaders: false,
      showTermsConditions: false,
      showTransactionOverview: false,
      singlePageFlow: false,
      storeAccount: true,
      tabs: true,
      zebraffeLoader: true,
      showTransactionsOnly: false,
      hideTxOverview: false,
      allowMobilePopup: false,
      fetchConfig: false
    },
    theme: {
      input: {
        color: '#222324',
        fontSize: '16px',
        height: '52px',
        borderRadius: '15px'
      },
      inputbackground: {
        color: '#ffffff'
      },
      labels: {
        color: '#000000',
        fontSize: '12px'
      },
      headings: {
        color: '#333',
        fontSize: '16px'
      },
      loader: {
        color: '#46beab'
      },
      error: {
        color: '#ED5F7B'
      },
      buttons: {
        color: '#46beab'
      },
      headerbackground: {
        color: '#46beab'
      },
      background: {
        color: '#ffffff'
      },
      cashierbackground: {
        color: '#ffffff'
      },
      cardbackground: {
        color: 'transparent'
      },
      border: {
        radius: '15px'
      },
      margin: {
        size: '20px'
      },
      creditcardicons: {
        creditcardUrl: 'default',
        cvvUrl: 'default',
        expirydateUrl: 'default'
      }
    },
    style: ''
  },
  'Default-eCommerce List': {
    includeInShowcase: true,
    label: 'Default-eCommerce List',
    config: {
      merchantId: '100211999',
      userId: 'PayTestGB',
      sessionId: '1234',
      environment: 'test',
      method: 'deposit',
      containerHeight: '625px',
      containerWidth: '800px',
      accountDelete: false,
      accountId: null,
      trackingPixels: null,
      additionalCashierText: true,
      allowCancelPendingWithdrawal: false,
      allowUserToDisableCancelWithdrawals: false,
      alwaysShowSubmitBtn: true,
      amount: '49.99',
      amountFirst: false,
      font: 'google,gilroy',
      autoOpenFirstPaymentMethod: true,
      autoProcess: false,
      bonusCode: null,
      channelId: null,
      country: '',
      disableBtnAtZero: false,
      displayLogoOrName: 'both',
      errorMsgTxRefId: false,
      feeAmount: [],
      gaTag: null,
      globalSubmit: false,
      history: false,
      isMobile: false,
      layout: 'horizontal',
      listRadio: true,
      listType: 'list',
      locale: '',
      logoFullWidth: false,
      logoSize: 120,
      logoUrl: 'https://static.paymentiq.io/misc/ShoppingCartBuyWhite.png',
      mode: 'ecommerce',
      pmListLimit: '6',
      pollLimit: 5,
      predefinedAmounts: '',
      predefinedValues: false,
      preventCancelWithdrawal: false,
      providerType: null,
      receiptAmountDisplayStyle: 'symbol',
      receiptAmountTransactionStyle: 'TxAmount',
      receiptExcludeKeys: [],
      showReceipt: true,
      saveAccountOption: false,
      scrollToOffset: 0,
      scrollToPm: 'nearest',
      selectlastusedtxmethod: false,
      showAccounts: 'inline',
      showAmountLimits: false,
      showBonusCode: false,
      showFee: false,
      showFooter: false,
      showHeader: true,
      showListHeaders: false,
      showTermsConditions: false,
      showTransactionOverview: false,
      singlePageFlow: false,
      storeAccount: true,
      tabs: true,
      zebraffeLoader: true,
      showTransactionsOnly: false,
      hideTxOverview: false,
      allowMobilePopup: false,
      fetchConfig: false
    },
    theme: {
      input: {
        color: '#222324',
        fontSize: '14px',
        height: '52px',
        borderRadius: '15px'
      },
      inputbackground: {
        color: '#ffffff'
      },
      labels: {
        color: '#000000',
        fontSize: '12px'
      },
      headings: {
        color: '#333',
        fontSize: '14px'
      },
      loader: {
        color: '#46beab'
      },
      error: {
        color: '#ED5F7B'
      },
      buttons: {
        color: '#46beab'
      },
      headerbackground: {
        color: '#46beab'
      },
      background: {
        color: '#ffffff'
      },
      cashierbackground: {
        color: '#ffffff'
      },
      cardbackground: {
        color: 'transparent'
      },
      border: {
        radius: '15px'
      },
      margin: {
        size: '14px'
      },
      creditcardicons: {
        creditcardUrl: 'default',
        cvvUrl: 'default',
        expirydateUrl: 'default'
      }
    },
    style: ''
  },
  'Showcase-Gambling Buttons-Green': {
    includeInShowcase: true,
    label: 'Showcase-Gambling Buttons-Green',
    config: {
      merchantId: '198003',
      userId: 'PayTestMT',
      sessionId: '1234',
      environment: 'test',
      method: 'deposit',
      containerHeight: '900px',
      containerWidth: '900px',
      accountDelete: false,
      accountId: null,
      trackingPixels: null,
      additionalCashierText: true,
      allowCancelPendingWithdrawal: true,
      allowUserToDisableCancelWithdrawals: false,
      alwaysShowSubmitBtn: true,
      amount: null,
      amountFirst: false,
      font: 'google,Comic Neue',
      autoOpenFirstPaymentMethod: true,
      autoProcess: false,
      bonusCode: null,
      channelId: null,
      country: '',
      disableBtnAtZero: true,
      displayLogoOrName: 'logo',
      errorMsgTxRefId: false,
      feeAmount: [],
      gaTag: null,
      globalSubmit: true,
      history: true,
      isMobile: false,
      layout: 'horizontal',
      listRadio: true,
      listType: 'grid',
      locale: '',
      logoFullWidth: true,
      logoSize: 120,
      logoUrl: 'https://static.paymentiq.io/misc/ChipsDepositIconWhite.png',
      mode: 'gambling',
      pmListLimit: '6',
      pollLimit: 5,
      predefinedAmounts: '10,25,50,100,250,500',
      predefinedValues: true,
      preventCancelWithdrawal: false,
      providerType: null,
      receiptAmountDisplayStyle: 'symbol',
      receiptAmountTransactionStyle: 'TxAmount',
      receiptExcludeKeys: [],
      showReceipt: true,
      saveAccountOption: false,
      scrollToOffset: 0,
      scrollToPm: 'nearest',
      selectlastusedtxmethod: false,
      showAccounts: 'inline',
      showAmountLimits: true,
      showBonusCode: false,
      showFee: true,
      showFooter: true,
      showHeader: true,
      showListHeaders: false,
      showTermsConditions: false,
      showTransactionOverview: true,
      singlePageFlow: false,
      storeAccount: true,
      tabs: true,
      zebraffeLoader: true,
      showTransactionsOnly: false,
      hideTxOverview: false,
      allowMobilePopup: false,
      fetchConfig: false
    },
    theme: {
      input: {
        color: '#222324',
        fontSize: '14px',
        height: '52px',
        borderRadius: '15px'
      },
      inputbackground: {
        color: '#ffffff'
      },
      labels: {
        color: '#000000',
        fontSize: '12px'
      },
      headings: {
        color: '#333',
        fontSize: '14px'
      },
      loader: {
        color: '#18723D'
      },
      error: {
        color: '#ED5F7B'
      },
      buttons: {
        color: '#FFAE12'
      },
      headerbackground: {
        color: '#18723D'
      },
      background: {
        color: '#ffffff'
      },
      cashierbackground: {
        color: '#ffffff'
      },
      cardbackground: {
        color: 'transparent'
      },
      border: {
        radius: '15px'
      },
      margin: {
        size: '14px'
      },
      creditcardicons: {
        creditcardUrl: 'default',
        cvvUrl: 'default',
        expirydateUrl: 'default'
      }
    },
    style: ''
  },
  'Showcase-Gambling ListBox-Green': {
    includeInShowcase: true,
    label: 'Showcase-Gambling ListBox-Green',
    config: {
      merchantId: '198003',
      userId: 'PayTestMT',
      sessionId: '1234',
      environment: 'test',
      method: 'deposit',
      containerHeight: '950px',
      containerWidth: '600px',
      accountDelete: false,
      accountId: null,
      trackingPixels: null,
      additionalCashierText: true,
      allowCancelPendingWithdrawal: true,
      allowUserToDisableCancelWithdrawals: false,
      alwaysShowSubmitBtn: true,
      amount: null,
      amountFirst: false,
      font: 'google, Kanit',
      autoOpenFirstPaymentMethod: true,
      autoProcess: false,
      bonusCode: null,
      channelId: null,
      country: '',
      disableBtnAtZero: true,
      displayLogoOrName: 'both',
      errorMsgTxRefId: false,
      feeAmount: [],
      gaTag: null,
      globalSubmit: false,
      history: true,
      isMobile: false,
      layout: 'horizontal',
      listRadio: true,
      listType: 'list',
      locale: '',
      logoFullWidth: true,
      logoSize: 120,
      logoUrl: 'https://static.paymentiq.io/misc/ChipsDepositIconWhite.png',
      mode: 'gambling',
      pmListLimit: '5',
      pollLimit: 5,
      predefinedAmounts: '10,25,50,100,250,500',
      predefinedValues: true,
      preventCancelWithdrawal: false,
      providerType: null,
      receiptAmountDisplayStyle: 'symbol',
      receiptAmountTransactionStyle: 'TxAmount',
      receiptExcludeKeys: [],
      showReceipt: true,
      saveAccountOption: false,
      scrollToOffset: 0,
      scrollToPm: 'nearest',
      selectlastusedtxmethod: false,
      showAccounts: 'inline',
      showAmountLimits: true,
      showBonusCode: false,
      showFee: true,
      showFooter: true,
      showHeader: true,
      showListHeaders: false,
      showTermsConditions: false,
      showTransactionOverview: true,
      singlePageFlow: true,
      storeAccount: true,
      tabs: false,
      zebraffeLoader: true,
      showTransactionsOnly: false,
      hideTxOverview: false,
      allowMobilePopup: false,
      fetchConfig: false
    },
    theme: {
      input: {
        color: '#222324',
        fontSize: '16px',
        height: '52px',
        borderRadius: '15px'
      },
      inputbackground: {
        color: '#ffffff'
      },
      labels: {
        color: '#000000',
        fontSize: '16px'
      },
      headings: {
        color: '#333',
        fontSize: '16px'
      },
      loader: {
        color: '#18723D'
      },
      error: {
        color: '#ff2e56'
      },
      buttons: {
        color: '#FFAE12'
      },
      headerbackground: {
        color: '#18723D'
      },
      background: {
        color: '#ffffff'
      },
      cashierbackground: {
        color: '#ffffff'
      },
      cardbackground: {
        color: 'transparent'
      },
      border: {
        radius: '15px'
      },
      margin: {
        size: '14px'
      },
      creditcardicons: {
        creditcardUrl: 'default',
        cvvUrl: 'default',
        expirydateUrl: 'default'
      }
    },
    style: ''
  },
  'Showcase-Gambling List-Le Bleu': {
    includeInShowcase: true,
    label: 'Showcase-Gambling List-Le Bleu',
    config: {
      merchantId: '198003',
      userId: 'PayTestMT',
      sessionId: '1234',
      environment: 'test',
      method: 'deposit',
      containerHeight: '85vh',
      containerWidth: '500px',
      accountDelete: false,
      accountId: null,
      trackingPixels: null,
      additionalCashierText: true,
      allowCancelPendingWithdrawal: false,
      allowUserToDisableCancelWithdrawals: false,
      alwaysShowSubmitBtn: true,
      amount: null,
      amountFirst: false,
      font: 'google, Fjalla one',
      autoOpenFirstPaymentMethod: true,
      autoProcess: false,
      bonusCode: null,
      channelId: null,
      country: '',
      disableBtnAtZero: true,
      displayLogoOrName: 'both',
      errorMsgTxRefId: false,
      feeAmount: [],
      gaTag: null,
      globalSubmit: false,
      history: true,
      isMobile: false,
      layout: 'vertical',
      listRadio: false,
      listType: 'list',
      locale: '',
      logoFullWidth: true,
      logoSize: 120,
      logoUrl: null,
      mode: 'gambling',
      pmListLimit: 15,
      pollLimit: 5,
      predefinedAmounts: '20,50,150',
      predefinedValues: true,
      preventCancelWithdrawal: false,
      providerType: null,
      receiptAmountDisplayStyle: 'symbol',
      receiptAmountTransactionStyle: 'TxAmount',
      receiptExcludeKeys: [],
      showReceipt: true,
      saveAccountOption: false,
      scrollToOffset: 0,
      scrollToPm: 'nearest',
      selectlastusedtxmethod: false,
      showAccounts: 'inline',
      showAmountLimits: true,
      showBonusCode: false,
      showFee: true,
      showFooter: true,
      showHeader: true,
      showListHeaders: false,
      showTermsConditions: false,
      showTransactionOverview: true,
      singlePageFlow: false,
      storeAccount: true,
      tabs: true,
      zebraffeLoader: true,
      showTransactionsOnly: false,
      hideTxOverview: false,
      allowMobilePopup: false,
      fetchConfig: false
    },
    theme: {
      input: {
        color: '#333333',
        fontSize: '14px',
        height: '52px',
        borderRadius: '10px'
      },
      inputbackground: {
        color: '#ffffff'
      },
      labels: {
        color: '#ffffff',
        fontSize: '12px'
      },
      headings: {
        color: '#ffffff',
        fontSize: '14px'
      },
      loader: {
        color: '#ffffff'
      },
      error: {
        color: '#ff2e56'
      },
      buttons: {
        color: '#555555'
      },
      headerbackground: {
        color: '#ffffff'
      },
      background: {
        color: '#ffffff'
      },
      cashierbackground: {
        color: 'linear-gradient(270deg,#4b6cb7,#182848)'
      },
      cardbackground: {
        color: 'transparent'
      },
      border: {
        radius: '10px'
      },
      margin: {
        size: '14px'
      },
      creditcardicons: {
        creditcardUrl: 'default',
        cvvUrl: 'default',
        expirydateUrl: 'default'
      }
    },
    style: allCss['Showcase-Gambling List-Le Bleu']
  },
  'Showcase-Gambling List-Big Blue': {
    label: 'Showcase-Gambling List-Big Blue',
    config: {
      merchantId: '198003',
      userId: 'PayTestMT',
      sessionId: '1234',
      environment: 'test',
      method: 'deposit',
      containerHeight: '950px',
      containerWidth: '600px',
      accountDelete: false,
      accountId: null,
      trackingPixels: null,
      additionalCashierText: true,
      allowCancelPendingWithdrawal: false,
      allowUserToDisableCancelWithdrawals: false,
      alwaysShowSubmitBtn: true,
      amount: null,
      amountFirst: false,
      font: 'google,gilroy',
      autoOpenFirstPaymentMethod: true,
      autoProcess: false,
      bonusCode: null,
      channelId: null,
      country: '',
      disableBtnAtZero: true,
      displayLogoOrName: 'both',
      errorMsgTxRefId: false,
      feeAmount: [],
      gaTag: null,
      globalSubmit: false,
      history: true,
      isMobile: false,
      layout: 'horizontal',
      listRadio: true,
      listType: 'list',
      locale: '',
      logoFullWidth: true,
      logoSize: 120,
      logoUrl: 'https://static.paymentiq.io/misc/ChipsDepositIconWhite.png',
      mode: 'gambling',
      pmListLimit: '5',
      pollLimit: 5,
      predefinedAmounts: '10,25,50,100,250,500',
      predefinedValues: true,
      preventCancelWithdrawal: false,
      providerType: null,
      receiptAmountDisplayStyle: 'symbol',
      receiptAmountTransactionStyle: 'TxAmount',
      receiptExcludeKeys: [],
      showReceipt: true,
      saveAccountOption: false,
      scrollToOffset: 0,
      scrollToPm: 'nearest',
      selectlastusedtxmethod: false,
      showAccounts: 'inline',
      showAmountLimits: true,
      showBonusCode: false,
      showFee: true,
      showFooter: true,
      showHeader: true,
      showListHeaders: false,
      showTermsConditions: false,
      showTransactionOverview: true,
      singlePageFlow: false,
      storeAccount: true,
      tabs: false,
      zebraffeLoader: true,
      showTransactionsOnly: false,
      hideTxOverview: false,
      allowMobilePopup: false,
      fetchConfig: false
    },
    theme: {
      input: {
        color: '#222324',
        fontSize: '18px',
        height: '52px',
        borderRadius: '15px'
      },
      inputbackground: {
        color: '#ffffff'
      },
      labels: {
        color: '#FFFFFF',
        fontSize: '25px'
      },
      headings: {
        color: '#FFFFFF',
        fontSize: '20px'
      },
      loader: {
        color: '#46beab'
      },
      error: {
        color: '#ff2e56'
      },
      buttons: {
        color: '#FF507D'
      },
      headerbackground: {
        color: '#7A1CFF'
      },
      background: {
        color: '#ffffff'
      },
      cashierbackground: {
        color: '#5B15C5'
      },
      cardbackground: {
        color: 'transparent'
      },
      border: {
        radius: '15px'
      },
      margin: {
        size: '14px'
      },
      creditcardicons: {
        creditcardUrl: 'default',
        cvvUrl: 'default',
        expirydateUrl: 'default'
      }
    },
    style: ''
  },
  'Showcase-Gambling Buttons-Desert Theme': {
    includeInShowcase: true,
    label: 'Showcase-Gambling Buttons-Desert Theme',
    config: {
      merchantId: '198003',
      userId: 'PayTestMT',
      sessionId: 123,
      environment: 'test',
      method: 'deposit',
      containerHeight: '625px',
      containerWidth: '900px',
      accountDelete: true,
      accountId: null,
      trackingPixels: null,
      additionalCashierText: true,
      allowCancelPendingWithdrawal: false,
      allowUserToDisableCancelWithdrawals: false,
      alwaysShowSubmitBtn: false,
      amount: null,
      amountFirst: false,
      font: 'google,Acme',
      autoOpenFirstPaymentMethod: true,
      autoProcess: false,
      bonusCode: null,
      channelId: null,
      country: 'swe',
      disableBtnAtZero: true,
      displayLogoOrName: 'both',
      errorMsgTxRefId: false,
      feeAmount: [],
      gaTag: null,
      globalSubmit: false,
      history: false,
      isMobile: false,
      layout: 'horizontal',
      listRadio: 'false',
      listType: 'grid',
      locale: 'en',
      logoFullWidth: true,
      logoSize: 120,
      logoUrl: null,
      mode: 'gambling',
      pmListLimit: '',
      pollLimit: 5,
      predefinedAmounts: '20,50,150',
      predefinedValues: true,
      preventCancelWithdrawal: false,
      providerType: null,
      receiptAmountDisplayStyle: 'symbol',
      receiptAmountTransactionStyle: 'TxAmount',
      receiptExcludeKeys: [],
      showReceipt: true,
      saveAccountOption: false,
      scrollToOffset: 0,
      scrollToPm: 'nearest',
      selectlastusedtxmethod: false,
      showAccounts: 'inline',
      showAmountLimits: false,
      showBonusCode: false,
      showFee: true,
      showFooter: true,
      showHeader: true,
      showListHeaders: false,
      showTermsConditions: false,
      showTransactionOverview: true,
      singlePageFlow: false,
      storeAccount: true,
      tabs: 'true',
      zebraffeLoader: true,
      showTransactionsOnly: false,
      hideTxOverview: false,
      allowMobilePopup: false,
      fetchConfig: false
    },
    theme: {
      input: {
        color: '#222324',
        fontSize: '14px',
        height: '52px',
        borderRadius: '20px'
      },
      inputbackground: {
        color: '#ffffff'
      },
      labels: {
        color: '#000000',
        fontSize: '16px'
      },
      headings: {
        color: '#333',
        fontSize: '16px'
      },
      loader: {
        color: '#46beab'
      },
      error: {
        color: '#ff2e56'
      },
      buttons: {
        color: '#B69372'
      },
      headerbackground: {
        color: '#B69372'
      },
      background: {
        color: '#B69372'
      },
      cashierbackground: {
        color: '#ffffff'
      },
      cardbackground: {
        color: 'transparent'
      },
      border: {
        radius: '20px'
      },
      margin: {
        size: '14px'
      },
      creditcardicons: {
        creditcardUrl: 'default',
        cvvUrl: 'default',
        expirydateUrl: 'default'
      }
    },
    style: allCss['Showcase-Gambling Buttons-Desert Theme']
  },
  'Default-CleanBasic': {
    label: 'Default-CleanBasic',
    config: {
      merchantId: '198003',
      userId: 'PayTestEUR',
      sessionId: 123,
      environment: 'test',
      method: 'deposit',
      containerHeight: '85vh',
      containerWidth: '500px',
      accountDelete: false,
      accountId: null,
      trackingPixels: null,
      additionalCashierText: true,
      allowCancelPendingWithdrawal: false,
      allowUserToDisableCancelWithdrawals: false,
      alwaysShowSubmitBtn: false,
      amount: null,
      amountFirst: false,
      font: 'google,gilroy',
      autoOpenFirstPaymentMethod: true,
      autoProcess: false,
      bonusCode: null,
      channelId: null,
      country: '',
      disableBtnAtZero: true,
      displayLogoOrName: 'both',
      errorMsgTxRefId: false,
      feeAmount: [],
      gaTag: null,
      globalSubmit: false,
      history: false,
      isMobile: false,
      layout: 'vertical',
      listRadio: true,
      listType: 'list',
      locale: '',
      logoFullWidth: true,
      logoSize: 120,
      logoUrl: null,
      mode: 'gambling',
      pmListLimit: 20,
      pollLimit: 5,
      predefinedAmounts: '10,25,50,100,250,500',
      predefinedValues: false,
      preventCancelWithdrawal: false,
      providerType: '',
      receiptAmountDisplayStyle: 'symbol',
      receiptAmountTransactionStyle: 'TxAmount',
      receiptExcludeKeys: [],
      showReceipt: true,
      saveAccountOption: false,
      scrollToOffset: 0,
      scrollToPm: 'nearest',
      selectlastusedtxmethod: false,
      showAccounts: 'inline',
      showAmountLimits: true,
      showBonusCode: false,
      showFee: false,
      showFooter: false,
      showHeader: true,
      showListHeaders: false,
      showTermsConditions: false,
      showTransactionOverview: false,
      singlePageFlow: false,
      storeAccount: true,
      tabs: false,
      zebraffeLoader: true,
      showTransactionsOnly: false,
      hideTxOverview: false,
      allowMobilePopup: false,
      fetchConfig: false
    },
    theme: {
      input: {
        color: '#222324',
        fontSize: '16px',
        height: '52px',
        borderRadius: '15px'
      },
      inputbackground: {
        color: '#ffffff'
      },
      labels: {
        color: '#000000',
        fontSize: '12px'
      },
      headings: {
        color: '#333',
        fontSize: '14px'
      },
      loader: {
        color: '#46beab'
      },
      error: {
        color: '#ff2e56'
      },
      buttons: {
        color: '#46beab'
      },
      headerbackground: {
        color: '#ffffff'
      },
      background: {
        color: '#ffffff'
      },
      cashierbackground: {
        color: '#ffffff'
      },
      cardbackground: {
        color: 'transparent'
      },
      border: {
        radius: '15px'
      },
      margin: {
        size: '14px'
      },
      creditcardicons: {
        creditcardUrl: 'default',
        cvvUrl: 'default',
        expirydateUrl: 'default'
      }
    },
    style: ''
  },
  'Default-eCommerce ListBox': {
    label: 'Default-eCommerce ListBox',
    config: {
      merchantId: '100211999',
      userId: 'PayTestGB',
      sessionId: '1234',
      environment: 'test',
      method: 'deposit',
      containerHeight: '725px',
      containerWidth: '450px',
      accountDelete: false,
      accountId: null,
      trackingPixels: null,
      additionalCashierText: true,
      allowCancelPendingWithdrawal: false,
      allowUserToDisableCancelWithdrawals: false,
      alwaysShowSubmitBtn: true,
      amount: '49.99',
      amountFirst: false,
      font: 'google,gilroy',
      autoOpenFirstPaymentMethod: true,
      autoProcess: false,
      bonusCode: null,
      channelId: null,
      country: '',
      disableBtnAtZero: false,
      displayLogoOrName: 'both',
      errorMsgTxRefId: false,
      feeAmount: [],
      gaTag: null,
      globalSubmit: false,
      history: false,
      isMobile: false,
      layout: 'horizontal',
      listRadio: true,
      listType: 'list',
      locale: '',
      logoFullWidth: false,
      logoSize: 120,
      logoUrl: 'https://static.paymentiq.io/misc/ShoppingCartBuyWhite.png',
      mode: 'ecommerce',
      pmListLimit: '6',
      pollLimit: 5,
      predefinedAmounts: '',
      predefinedValues: false,
      preventCancelWithdrawal: false,
      providerType: null,
      receiptAmountDisplayStyle: 'symbol',
      receiptAmountTransactionStyle: 'TxAmount',
      receiptExcludeKeys: [],
      showReceipt: true,
      saveAccountOption: false,
      scrollToOffset: 0,
      scrollToPm: 'nearest',
      selectlastusedtxmethod: false,
      showAccounts: 'inline',
      showAmountLimits: false,
      showBonusCode: false,
      showFee: false,
      showFooter: false,
      showHeader: true,
      showListHeaders: false,
      showTermsConditions: false,
      showTransactionOverview: false,
      singlePageFlow: true,
      storeAccount: true,
      tabs: true,
      zebraffeLoader: true,
      showTransactionsOnly: false,
      hideTxOverview: false,
      allowMobilePopup: false,
      fetchConfig: false
    },
    theme: {
      input: {
        color: '#222324',
        fontSize: '14px',
        height: '52px',
        borderRadius: '15px'
      },
      inputbackground: {
        color: '#ffffff'
      },
      labels: {
        color: '#000000',
        fontSize: '12px'
      },
      headings: {
        color: '#333',
        fontSize: '14px'
      },
      loader: {
        color: '#46beab'
      },
      error: {
        color: '#ED5F7B'
      },
      buttons: {
        color: '#46beab'
      },
      headerbackground: {
        color: '#46beab'
      },
      background: {
        color: '#ffffff'
      },
      cashierbackground: {
        color: '#ffffff'
      },
      cardbackground: {
        color: 'transparent'
      },
      border: {
        radius: '15px'
      },
      margin: {
        size: '14px'
      },
      creditcardicons: {
        creditcardUrl: 'default',
        cvvUrl: 'default',
        expirydateUrl: 'default'
      }
    },
    style: ''
  }
}
